<p-toast [key]="'appToast'" [baseZIndex]="5000"> </p-toast>
<!-- main app container -->
<div class="notranslate">
  <router-outlet></router-outlet>
</div>
